import {
  Datagrid,
  DateField,
  List,

  TextField,
  TextInput,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  SimpleForm,
  Edit,
  ArrayInput,
  SimpleFormIterator,
  SingleFieldList,
  ChipField,
  ArrayField,

  usePermissions,


  Show,

  ReferenceArrayInput,
  AutocompleteArrayInput,
  ReferenceArrayField,

  useRecordContext,
  Create,

  AutocompleteInput,

  Filter,
  FileField
} from "react-admin";

import { makeStyles } from "@material-ui/core/styles";


import {


  Grid,
  Chip,


} from '@mui/material';

import { isMobile } from 'react-device-detect';

import React, { useState } from 'react';

// import { useQuery, Pagination, Loading, ListContextProvider } from 'react-admin'
// import { Link } from 'react-router-dom';

// import { Card } from '@mui/material';

// import CreateView from '../../../components/CreateView';
// import EditView from '../../../components/EditView';
// import { CONATACTPRIORITY, TypeOfCu } from '../../../constants/choices';
import { ClueCreateCommentButton } from './ClueCreateButton';


import { ROLES, SERVER } from "../../../constants";
import { ColoredChipField } from "../../needs/Needs";
// import { Add, TextRotationAngleupOutlined } from "@material-ui/icons";
import { IdateTimeInput } from '../../../data/IdateTimeInput';
// import ShowActionsPermission from "../../../components/ShowActionsWithPermission";
import { HttpClient } from "../../../utils/requests";

import { Aside } from "../CRMAside";
import ShowActionsPermissionOnlyEdit from "../../../components/ShowActionsWithPermissionOnlyEdit";
import { RaFileInput } from "../../../components/RaFileUploader";

export const useFileStyleList = makeStyles({
  fileContainer: {
    '& a': {
      outline: 'none',
      'text-decoration': 'none',
      padding: '2px 1px 0',
      color: 'black',
      lineHeight: 3,
      'padding-left': '10px',
      'padding-right': '10px',

    },

    '& a:link': {
      'border-radius':"10px",
      background: '#cdfeaa',
      color: 'black',
    },
    // '& a:active': {
    //   outline: "none",
    //   background: "#265301",
    //   color: "#cdfeaa",
    // },
    '& a:hover': {
      background: 'palegoldenrod',

    }
  }
});

export const DatagridUsersProps = {
  rowStyle: (record, index) => {
    return {
      height: "75px",
      borderWidth: "1.2px",
      borderColor: "#000",
      marginBottom: "30px",
    };
  }
};
const DatagridInnerProps = {
  rowStyle: (record, index) => {
    return {
      borderWidth: "2px",
      borderColor: "#fff",
    };
  }
};

// const DatagridHeader = (props) => (
//   <TableHead>

//   </TableHead>
// );

const FilterClue = (props) => {

  return (
    <Filter {...props}>
      <ReferenceInput variant="outlined" source="callResult" reference="statusCall">
        <SelectInput optionText="title" />
      </ReferenceInput>
      <ReferenceInput variant="outlined" source="ownerAdmin.name" reference="ownerAdmin.name">
        <SelectInput optionText="title" />
      </ReferenceInput>
      {/* <AutocompleteInput optionText="refNum" alwaysOn/> */}
      <TextInput label=" تعداد" source="count" variant="outlined" />

      <ReferenceInput label=" کالا" variant="outlined" source="productCRM" reference="orderType" >
        <SelectInput source="title" optionText="title" />
      </ReferenceInput>
      <ReferenceInput variant="outlined" label=" بسته‌بندی " source="typeOfBox" reference="package" >
        <SelectInput optionText="title" />
      </ReferenceInput>

      <TextInput label=" قیمت" variant="outlined" source="price" />
      <TextInput label=" وزن" variant="outlined" source="weight" />

      <TextInput label=" تخفیف" variant="outlined" source="discount" />


      {/* <SearchInput variant="outlined" resettable source="q" alwaysOn /> */}
    </Filter>
  )
};


export const ClueList = (props) => {
  return (
    //رتبه مخاطب
    <List {...props} perPage={40} sort={{ field: 'updatedAt', order: 'DESC' }} filters={<FilterClue />}>
      {isMobile ? (
        <Datagrid rowClick="show">
          <TextField source="title" label="عنوان " />
          
          {/* <TextField source="contactName" label="تماس گیرنده" />
          <ReferenceField link={null} label="وضعیت تماس" source="callResult" reference="statusCall" >
            <ColoredChipField source="title" select="id" />
          </ReferenceField> */}
          <ArrayField source="order" label="سفارش">
            <Datagrid style={{ margin: "10px" }}>
              <TextField label="تعداد" source="count" style={{ fontSize: "8pt" }} />
              <ReferenceField link={null} label=" سفارش" source="productCRM" reference="orderType">
                <TextField source="title" style={{ fontSize: "8pt" }} />
              </ReferenceField>
            </Datagrid>
          </ArrayField>
        </Datagrid>
      ) : (
        <Datagrid rowClick="show" {...DatagridUsersProps}
        >
          <DateField label="زمان تماس" source="callTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
          {/* <TextField source="clueRefId" /> */}
          <ChipField label="ایجاد کننده " variant="outlined" source="ownerAdmin.name" select="id" />
          <TextField source="contactName" label="تماس گیرنده" />

          <ArrayField source="order" label="تعداد / نوع جعبه /  کالا  /    قیمت    /   وزن      / تخفیف">
            <Datagrid header="false" {...DatagridInnerProps} >
              <TextField label="" source="count" style={{ fontSize: "8pt" }} />
              <ReferenceField link={null} label=" " source="typeOfBox" reference="package">
                <TextField source="title" style={{ fontSize: "8pt" }} />
              </ReferenceField>
              <ReferenceField link={null} label=" " source="productCRM" reference="orderType">
                <TextField source="title" style={{ fontSize: "8pt" }} />
              </ReferenceField>
              <TextField label="" source="price" style={{ fontSize: "8pt" }} />
              <TextField label="" source="weight" style={{ fontSize: "8pt" }} />

              <TextField label="" source="discount" style={{ fontSize: "8pt" }} />
            </Datagrid>
          </ArrayField>
          <ReferenceField link={null} label="وضعیت تماس" source="callResult" reference="statusCall" >
            <ColoredChipField source="title" select="id" />
          </ReferenceField>
          <TextField source="title" label="عنوان " />
        </Datagrid>
      )}

    </List >
  )
};
// const TextFieldApproved = ({ record }) => (
//   <ul>
//     {record.name}&nbsp;
//     {record.approved ? <VerifiedIcon fontSize="small" color="#0e79f3" /> : <WarningIcon fontSize="small" color="error" />}
//   </ul>
// )

export const ClueEdit = (props) => {
  const classes = useFileStyleList();

  return (
    <Edit {...props}>
      <SimpleForm submitOnEnter={false} variant="outlined" redirect="list" >
        <TextInput source="phoneNumber" label="شماره تماس" />

        <IdateTimeInput source='callTime' label="زمان تماس" />
        <TextInput source="contactName" label="نام مخاطب" />

        {/* <ClueCreateButton type="HOGHUGHI" /> */}

        <TextInput source="title" label="عنوان" variant='outlined' />
        <ReferenceArrayInput source="users" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >
        <ReferenceInput label="مشتری" source="company" reference="customer">
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <TextInput source="companyName" label="نام مشتری" />

        <ArrayInput source="order" >
          <SimpleFormIterator TransitionProps={{ enter: false, exit: false }}  >
            <TextInput label=" تعداد" source="count" />

            <ReferenceInput label=" سفارش" source="productCRM" reference="orderType" >
              <SelectInput optionText="title" />
            </ReferenceInput>
            <ReferenceInput label=" بسته‌بندی " source="typeOfBox" reference="package" >
              <SelectInput optionText="title" />
            </ReferenceInput>

            <TextInput label=" قیمت" source="price" />
            <TextInput label=" وزن" source="weight" />

            <TextInput label=" تخفیف" source="discount" />

          </SimpleFormIterator>
        </ArrayInput>
        <TextInput source="description" multiline rows={5} width="60%" />

        <ReferenceInput source="callResult" reference="statusCall">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <FileField className={classes.fileContainer} label="فایل‌های ضمیمه" source="attachments" src="url" title="name" target="_blank" />
        <RaFileInput
          style={{ width: '50%' }}
          fullwidth={false}
          source="file"
          label="سند مربوطه"
          classes={{
            root: classes.classFile
          }}
          options={{ type: "clue" }}
          accept=""
          className={'classFile'}
          uploadEndpoint={`${SERVER}/admin/file`}
        />

      </SimpleForm>
    </Edit>
  )
};
export const StarChipField = props => {
  const record = useRecordContext();
  let phone = record.phoneNumber

  phone = phone.substring(phone.length - (phone.length / 2), phone.length) + '*'.repeat(phone.length / 2);
  return (
    <Chip label={phone} />
  );
};

export const ClueShow = (props) => {
  // const [page, setPage] = useState(1);
  const classes = useFileStyleList();

  const { permissions } = usePermissions();
  // const createProps = { record: { "clueName": 'myValue' } }
  // const perPage = 1;
  return (

    <Show
      actions={<ShowActionsPermissionOnlyEdit />}
      style={{ marginRight: "8px" }}  {...props} variant="outlined" aside={<Aside sx={{ height: "40px" }} />} >
      <div>
        <div style={{
          margin: "16px 0px",
          position: "absolute",
          left: "10vh",
          top: "6vh"
        }}>
          <ClueCreateCommentButton clue={props}
          />
        </div>

        <Grid container spacing={2} style={{ marginRight: "16px", marginLeft: "16px"  }}>
          <Grid item xs={6}>
            <br />
            تماس گیرنده
            <ReferenceField link={permissions?.includes(ROLES.SUPER_ADMIN) ? 'show' : null} label="تماس گیرنده" source="contact" reference="contact">
              <ChipField source="name" />
            </ReferenceField>
            <br />
            شماره تماس
            <StarChipField source="phoneNumber" />
            <br />

            عنوان <ChipField source="title" />
            <br />
            <ReferenceField link="show" source="ownerAdmin" reference="adminUsers" >
              <TextField source="name" />
            </ReferenceField>
            همکاران  <br /> <br /><ReferenceArrayField source="users" reference="adminUsers" >
              <SingleFieldList linkType={null}>
                <ChipField source="name" />
              </SingleFieldList>
            </ReferenceArrayField>
          </Grid>
          <Grid item xs={6}>

            <br />
            ایجاد کننده
            <ChipField source="ownerAdmin.name" />

            <br />
            وضعیت تماس

            <ReferenceField link={null} source="callResult" reference="statusCall" >
              <ColoredChipField source="title" select="id" />
            </ReferenceField>

          </Grid>
          <Grid item xs={5}>
            سفارش
            <br />
            <ArrayField source="order" label="">
              <Datagrid>
                <TextField label="تعداد" source="count" style={{ fontSize: "8pt" }} />
                <ReferenceField link={null} label=" بسته" source="typeOfBox" reference="package">
                  <TextField source="title" style={{ fontSize: "8pt" }} />
                </ReferenceField>

                <ReferenceField link={null} label="محصول" source="productCRM" reference="orderType">
                  <TextField source="title" style={{ fontSize: "8pt" }} />
                </ReferenceField>
                <TextField label="قیمت" source="price" style={{ fontSize: "8pt" }} />
                <TextField label="وزن" source="weight" style={{ fontSize: "8pt" }} />

                <TextField label="تخفیف" source="discount" style={{ fontSize: "8pt" }} />
              </Datagrid>
            </ArrayField>
            <br />
            <br />
            <br />
            {permissions?.includes(ROLES.SUPER_ADMIN) && <>مشتری
              <ReferenceField link="show" source="company" reference="customer" >
                <ChipField source="name" />
              </ReferenceField>
              <br />


            </>}
            نام مشتری <ChipField source="companyName" />
            <br />
            <br />
            فایل های ضمیمه
            <br />
            <FileField source="attachments" className={classes.fileContainer} src="url" title="name" target="_blank" />
            <br />
            <br />
            زمان تماس <br /><DateField source="callTime" options={{ weekday: 'long', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
            <br />
            <br />
            یادداشت <ChipField source="description" style={{ fontSize: "8pt" }} />

          </Grid>
        </Grid>


        <br />


      </div>
    </Show >
  )
};
export const ClueCreate = (props) => {
  const [contactData, setContactData] = useState({ contact: undefined })
  const [disableInput, setDisableInput] = useState(false)

  // const [needData, setNeedData] = useState({ needs: [] })

  // const { setValue } = useForm();
  // const form = useForm();

  const handlePhoneChange = (event) => {
    console.log("injaa change", event.target.value)
    // const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);
    HttpClient(SERVER + `/admin/contact/phone/` + event.target.value, {
      method: "GET",
    })
      .then(({ headers, json }) => {
        if (json.result) {
          setContactData(json.result)
          setDisableInput(true)
          // setValue("contactName", json.result.name);
          // form.change("contactName", json.result.name);

        } else {
          setDisableInput(false)

        }

      })
      .catch((e) => {
      });

  }


  return (
    <Create {...props} class="flex-column">
      <SimpleForm submitOnEnter={false} variant="outlined" redirect="list" >
        <TextInput source="phoneNumber" label="شماره تماس" onChange={handlePhoneChange} />

        <IdateTimeInput source='callTime' label="زمان تماس" />
        <TextInput type="text" defaultValue={contactData.name} disabled={disableInput} source="contactName" label="نام مخاطب" />

        {/* <ClueCreateButton type="HOGHUGHI" /> */}

        <TextInput source="title" label="عنوان" variant='outlined' />
        <ReferenceArrayInput defaultValue={contactData?.users} source="users" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >
        <ReferenceInput defaultValue={contactData?.company} label="مشتری‌های من" source="company" reference="customer">
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <TextInput source="companyName" label="نام مشتری" />

        <ArrayInput source="order" >
          <SimpleFormIterator TransitionProps={{ enter: false, exit: false }}  >
            <TextInput label=" تعداد" source="count" />
            <ReferenceInput label="محصول " source="productCRM" reference="orderType" >
              <SelectInput optionText="title" />
            </ReferenceInput>

            <ReferenceInput label=" بسته‌بندی " source="typeOfBox" reference="package" >
              <SelectInput optionText="title" />
            </ReferenceInput>

            <TextInput label=" قیمت" source="price" />
            <TextInput label=" وزن" source="weight" />

            <TextInput label=" تخفیف" source="discount" />

          </SimpleFormIterator>
        </ArrayInput>
        <TextInput source="description" multiline rows={5} width="60%" />

        <ReferenceInput source="callResult" reference="statusCall">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <RaFileInput
          fullwidth={false}
          source="file"
          label="سند مربوطه"
          options={{ type: "clue" }}
          accept=""
          className={'classFile'}
          uploadEndpoint={`${SERVER}/admin/file`}
        />
      </SimpleForm>
    </Create >
  )
};

// const ListActions = (props) => (
//   <TopToolbar>
//     <CreateButton />
//   </TopToolbar>
// );





// const BoundedTextInput = (props) => {
//   const {
//     input: { name, onChange, ...rest },
//     meta: { touched, error },
//     isRequired
//   } = useInput(props);

//   return (
//     <TextInput
//       name="phone"
//       variant="outline"
//       label={props.label}
//       onChange={onChange}
//       {...rest}
//     />
//   );
// };


// CreateHoghughi